import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { FilterTriggerButtonComponent } from "./filter-trigger-button.component";

@NgModule({
	declarations: [FilterTriggerButtonComponent],
	imports: [CommonModule, MaterialModule, TranslateModule],
	exports: [FilterTriggerButtonComponent],
})
export class FilterTriggerButtonModule {}
